module.exports = __webpack_public_path__ + "assets/img/wallpaper.9692d189.jpg";